import { AxiosResponse } from "axios";
import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import {
  AddMemoReq,
  changeDocNameResp,
  ContentLink,
  DocAIChatRequest,
  DocAIChatRespond,
  DocDetailDto,
  DocDownloadRequestDTO,
  DocRestoreData,
  DocumentListReq,
  DocumentListResp,
  DocumentLogResult,
  FileFolderReq,
  Folder,
  FolderInfoDTO,
  FolderTagFilesUpdateResponse,
  FwocFilesLicensesRequestDTO,
  MemoDTO,
  ReadReqeustDto,
  ReadRequestDto,
  RemoveUploadUidResponse,
  RequestRespond,
  UploadCompleteRequestDTO,
  UserViewCountPolicy,
  WrapsodySetFedTagRequest,
  WrapsodySetRevisionMemoResult,
  WrapsodySyncInfoResponse,
} from "../../types/files";
import axiosBlob from "../../shared/utils/axiosBlob";
import axiosNoLoading from "../../shared/utils/axiosNoLoading";
import utilsCommon from "../../shared/utils/common";
import { FileWithPath } from "react-dropzone/.";
import { BasicReturnMsg } from "../../types/common";
import { DeliveryUIDRequestRespondDTO } from "../../types/adminSetting";

const GATEWAY_URL = config.servers.gateway.url;

interface DocApi {
  getContentDetail(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<DocDetailDto>;
  getContentSimpleDetail(
    syncId: string
  ): Promise<{ contentName: string; fileSize: number }>;
  getContentFavorite(req: {
    flag: boolean;
    syncIds: string[];
  }): Promise<{ flag: boolean; syncIds: string[] }>;
  getContentThumbnail(req: {
    syncId: string;
    revisionNo: number;
  }): Promise<any>;
  getContentList(req: DocumentListReq): Promise<DocumentListResp>;
  getReadRequestContentList(req: ReadRequestDto): Promise<ReadRequestDto>;
  addContentMemo(
    req: AddMemoReq
  ): Promise<{ revisionNo: number; syncId: string; ver: string }>;
  getDocUsingByWebIncludeToken(req: FwocFilesLicensesRequestDTO): Promise<any>;
  docDownload(req: DocDownloadRequestDTO): Promise<any>;
  docDecrpytDownload(req: DocDownloadRequestDTO): Promise<any>;
  docsDownload(syncIds: string[], startDownload: any): Promise<any>;
  docsDownloadCheck(syncIds: string[]): Promise<any>;
  docDelete(syncIds: string[]): Promise<WrapsodySetFedTagRequest>;
  docDeleteNow(syncIds: string[]): Promise<{
    ver: string;
    fails: string[];
  }>;
  docRestore(syncIds: string[]): Promise<DocRestoreData[]>;
  docUploadUidCreate(): Promise<string>;
  docUploadFile(
    uid: string,
    file: FileWithPath,
    setProgressPercent: any
  ): Promise<any>;
  docRemoveFileFromUid(
    uid: string,
    fileId: string
  ): Promise<RemoveUploadUidResponse>;
  changeDocName(req: {
    contentName: string;
    syncId: string;
  }): Promise<changeDocNameResp>;
  changeDocMaster(
    syncId: string | string[],
    fromUserId: string,
    toUserId: string,
    rev: number
  ): Promise<ContentLink>;
  getMemos(reqDTO: MemoDTO): Promise<WrapsodySetRevisionMemoResult>;
  docRequestRead(req: ReadReqeustDto): Promise<ReadReqeustDto>;
  requestLists(syncId: string): Promise<RequestRespond[]>;
  requestReadDelete(syncId: string, requestId: string): Promise<BasicReturnMsg>;
  checkoutManualDoc(req: {
    syncId: string;
    revisionNo: number;
    workgroupId: string;
  }): Promise<BasicReturnMsg>;
  undocheckoutManualDoc(req: {
    syncId: string;
    revisionNo: number;
    workgroupId: string;
  }): Promise<BasicReturnMsg>;
  createFolder(folder: FileFolderReq): Promise<FolderInfoDTO>;
  updateFolder(folder: FileFolderReq): Promise<FolderInfoDTO>;
  deleteFolder(folder: FileFolderReq): Promise<FolderInfoDTO>;
  docUploadFileDelivery(
    req: DeliveryUIDRequestRespondDTO
  ): Promise<DeliveryUIDRequestRespondDTO>;
  docUploadFileComplete(
    uid: string,
    req: UploadCompleteRequestDTO,
    isLoading?: boolean
  ): Promise<any>;
  docUploadFileCompleteDelivery(
    uid: string,
    req: UploadCompleteRequestDTO
  ): Promise<any>;
  getDocSyncInfo(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<WrapsodySyncInfoResponse>;
  forceWebCheckin(syncId: string): Promise<BasicReturnMsg>;
  webCheckin(
    workgroupId: string,
    syncId: string,
    revisionNo: number
  ): Promise<BasicReturnMsg>;
  doAIDocChat(chatRequest: DocAIChatRequest): Promise<DocAIChatRespond>;
  closeAIDocChat(convoId: string): Promise<any>;
  cancelAIDocChat(request: DocAIChatRequest): Promise<any>;
  checkAIDocPermission(syncIds: string[]): Promise<any>;
  checkAnswerDocChat(request: DocAIChatRequest): Promise<DocAIChatRespond>;
  getFolderInfo(folderId: string): Promise<Folder>;
  updateFileFolder(
    folder: FileFolderReq
  ): Promise<FolderTagFilesUpdateResponse>;
  docUploadRevisionFile(
    uid: string,
    file: FileWithPath,
    syncId: string,
    setProgressPercent: any
  ): Promise<any>;
  getUploadDocsProgress(uid: string): Promise<any>;
  getDocTimeline(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<DocumentLogResult>;
  getDocUserViewCount(req: {
    syncId: string;
    workgroupId: string;
  }): Promise<UserViewCountPolicy[]>;
}

class DocServerApi implements DocApi {
  async getContentDetail(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<any> {
    const resp = await axios.get<DocDetailDto>(
      `${GATEWAY_URL}/wapi/contents/detail/${req.workgroupId}/${req.syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async getContentSimpleDetail(
    syncId: string
  ): Promise<{ contentName: string; fileSize: number }> {
    const resp = await axios.get<{ contentName: string; fileSize: number }>(
      `${GATEWAY_URL}/papi/file/detail/${syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async getContentFavorite(req: {
    flag: boolean;
    syncIds: string[];
  }): Promise<{ flag: boolean; syncIds: string[] }> {
    const resp = await axios.post<{ flag: boolean; syncIds: string[] }>(
      `${GATEWAY_URL}/wapi/contents/favorite`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async getContentThumbnail(req: {
    syncId: string;
    revisionNo: number;
  }): Promise<any> {
    const resp = await axiosNoLoading.get<any>(
      `${GATEWAY_URL}/wapi/contents/thumbnail/${req.syncId}/${req.revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
  async getContentList(req: DocumentListReq): Promise<DocumentListResp> {
    const resp = await axios.post<DocumentListResp>(
      `${GATEWAY_URL}/wapi/contents/list`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async getReadRequestContentList(
    req: ReadRequestDto
  ): Promise<ReadRequestDto> {
    const resp = await axios.post<ReadRequestDto>(
      `${GATEWAY_URL}/wapi/contents/request/read/unread`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async addContentMemo(
    req: AddMemoReq
  ): Promise<{ revisionNo: number; syncId: string; ver: string }> {
    const resp = await axios.post<{
      revisionNo: number;
      syncId: string;
      ver: string;
    }>(`${GATEWAY_URL}/wapi/contents/comment`, req);
    return Promise.resolve(resp.data);
  }
  async getDocUsingByWebIncludeToken(
    req: FwocFilesLicensesRequestDTO
  ): Promise<any> {
    const resp = await axios.get<{
      revisionNo: number;
      syncId: string;
      ver: string;
    }>(
      `${GATEWAY_URL}/wapi/contents/webusing/${req.permission}/${req.workgroupId}/${req.syncId}/${req.revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
  async docsDownload(syncIds: string[], startDownload: any): Promise<any> {
    try {
      const resp =
        syncIds.length === 1
          ? await axiosBlob.get<AxiosResponse>(
              `${GATEWAY_URL}/wapi/contents/download/${syncIds[0]}/revisions/0`,
              {
                responseType: "blob",
                timeout: 0,
                maxContentLength: Infinity,
                onDownloadProgress: (progressEvent) => {
                  if (progressEvent.loaded) {
                    startDownload(progressEvent.loaded);
                  }
                },
              }
            )
          : await axiosBlob.post<AxiosResponse>(
              `${GATEWAY_URL}/wapi/contents/download/`,
              syncIds,
              {
                responseType: "blob",
                timeout: 0,
                maxContentLength: Infinity,
                onDownloadProgress: (progressEvent) => {
                  if (progressEvent.loaded) {
                    startDownload(progressEvent.loaded);
                  }
                },
              }
            );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async docsDownloadCheck(syncIds: string[]): Promise<any> {
    const resp = await axios.post<AxiosResponse>(
      `${GATEWAY_URL}/wapi/contents/downloadCheck`,
      syncIds
    );

    if (resp.status !== 200) {
      return resp;
    }
    return Promise.resolve({ data: resp.data, headers: resp.headers });
  }
  async docDownload(req: DocDownloadRequestDTO): Promise<any> {
    let resp: any;
    try {
      if (utilsCommon.isClientLogin("MAC")) {
        (window as any)?.webkit?.messageHandlers.downloadDocument.postMessage({
          syncId: req.syncId,
          revisionVersion: req.revisionNo,
          contentName: req.contentName,
        });
      } else {
        if (req.revisionNo) {
          resp = await axiosBlob.get<AxiosResponse>(
            `${GATEWAY_URL}/wapi/contents/download/${req.syncId}/revisions/${req.revisionNo}`,
            {
              responseType: "blob",
              timeout: 0,
              maxContentLength: Infinity,
              onDownloadProgress: (progressEvent: any) => {
                if (progressEvent.loaded) {
                  req.startDownload(progressEvent.loaded);
                }
              },
            }
          );
        } else {
          resp = await axiosBlob.get<AxiosResponse>(
            `${GATEWAY_URL}/wapi/contents/download/${req.syncId}/revisions/0`,
            {
              responseType: "blob",
              timeout: 0,
              maxContentLength: Infinity,
              onDownloadProgress: (progressEvent) => {
                if (progressEvent.loaded) {
                  req.startDownload(progressEvent.loaded);
                }
              },
            }
          );
        }
      }

      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async docDecrpytDownload(req: DocDownloadRequestDTO): Promise<any> {
    let resp: any;
    try {
      if (utilsCommon.isClientLogin("MAC")) {
        (
          window as any
        )?.webkit?.messageHandlers.downloadDocumentDecrypt.postMessage({
          syncId: req.syncId,
          revisionVersion: req.revisionNo,
          contentName: req.contentName,
        });
      } else {
        resp = await axiosBlob.get<AxiosResponse>(
          `${GATEWAY_URL}/wapi/contents/download/${req.syncId}/revisions/${req.revisionNo}/decrypt`,
          {
            responseType: "blob",
            timeout: 0,
            maxContentLength: Infinity,
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.loaded) {
                req.startDownload(progressEvent.loaded);
              }
            },
          }
        );
      }

      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async docDelete(syncIds: string[]): Promise<WrapsodySetFedTagRequest> {
    const resp = await axiosNoLoading.post<WrapsodySetFedTagRequest>(
      `${GATEWAY_URL}/wapi/contents/delete`,
      {
        syncIds,
      }
    );
    return Promise.resolve(resp.data);
  }
  async docDeleteNow(syncIds: string[]): Promise<{
    ver: string;
    fails: string[];
  }> {
    const resp = await axios.post<{
      ver: string;
      fails: string[];
    }>(`${GATEWAY_URL}/wapi/contents/delete/now`, {
      syncIds,
    });
    return Promise.resolve(resp.data);
  }
  async docRestore(syncIds: string[]): Promise<DocRestoreData[]> {
    const resp = await axios.post<DocRestoreData[]>(
      `${GATEWAY_URL}/wapi/contents/restore`,
      {
        syncIds,
      }
    );
    return Promise.resolve(resp.data);
  }
  async docUploadUidCreate(): Promise<string> {
    const resp = await axiosNoLoading.post<{ uniqueId: string }>(
      `${GATEWAY_URL}/wapi/contents/upload/uid/create`,
      {}
    );
    return Promise.resolve(resp.data.uniqueId);
  }
  async docUploadFile(
    uid: string,
    file: File,
    setProgressPercent: any
  ): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    let resp;
    try {
      if (setProgressPercent === null) {
        resp = await axios.post<AxiosResponse>(
          `${GATEWAY_URL}/wapi/contents/upload/${uid}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        resp = await axiosNoLoading.post<AxiosResponse>(
          `${GATEWAY_URL}/wapi/contents/upload/${uid}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (data) => {
              //Set the progress value to show the progress bar
              data?.total &&
                setProgressPercent(
                  Math.round((100 * data.loaded) / data?.total)
                );
            },
          }
        );
      }
      return Promise.resolve(resp.data);
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async docRemoveFileFromUid(
    uid: string,
    fileId: string
  ): Promise<RemoveUploadUidResponse> {
    if (fileId !== "") {
      const resp = await axios.post<RemoveUploadUidResponse>(
        `${GATEWAY_URL}/wapi/contents/upload/${uid}/delete/${fileId}`
      );
      return Promise.resolve(resp.data);
    } else {
      return Promise.resolve({
        entryTime: 0,
        fileInfoList: [],
        status: "",
        uniqueId: fileId,
        userId: "",
      });
    }
  }
  async changeDocName(req: {
    contentName: string;
    syncId: string;
  }): Promise<changeDocNameResp> {
    const resp = await axios.post<changeDocNameResp>(
      `${GATEWAY_URL}/wapi/contents/docname`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async changeDocMaster(
    syncId: string | string[],
    fromUserId: string,
    toUserId: string,
    rev: number
  ): Promise<ContentLink> {
    const resp = await axios.post<ContentLink>(
      `${GATEWAY_URL}/wapi/contents/master/changes`,
      {
        master: { fromUserId: fromUserId, toUserId: toUserId },
        syncIds: typeof syncId === "string" ? [syncId] : syncId,
      }
    );
    //  const resp = await axios.post<ContentLink>(
    //   syncId.length === 1
    //     ? `${GATEWAY_URL}/wapi/contents/master/${syncId}/${rev}`
    //     : `${GATEWAY_URL}/wapi/contents/master/changes`,
    //   {
    //     master: { fromUserId: fromUserId, toUserId: toUserId },
    //     syncIds: syncId.length === 1 ? undefined : syncId,
    //   }
    // );
    return Promise.resolve(resp.data);
  }
  async getMemos(reqDTO: MemoDTO): Promise<WrapsodySetRevisionMemoResult> {
    let resp: any;
    if (reqDTO.cursor) {
      resp = await axios.get<DocumentLogResult>(
        `${GATEWAY_URL}/wapi/logs/doc/` +
          reqDTO.syncId +
          "/" +
          reqDTO.cursor +
          "/" +
          reqDTO.revisionNo
      );
    } else {
      resp = await axios.get<DocumentLogResult>(
        `${GATEWAY_URL}/wapi/logs/doc/` + reqDTO.syncId
      );
    }
    return Promise.resolve(resp.data);
  }
  async docRequestRead(req: ReadReqeustDto): Promise<ReadReqeustDto> {
    const resp = await axios.post<ReadReqeustDto>(
      `${GATEWAY_URL}/wapi/contents/request/read`,
      req
    );
    return Promise.resolve(resp.data);
  }
  async requestLists(syncId: string): Promise<RequestRespond[]> {
    const resp = await axios.get<RequestRespond[]>(
      `${GATEWAY_URL}/wapi/contents/request/read/${syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async requestReadDelete(
    syncId: string,
    requestId: string
  ): Promise<BasicReturnMsg> {
    const resp = await axios.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/contents/request/read/${syncId}/${requestId}/delete`
    );
    return Promise.resolve(resp.data);
  }
  async checkoutManualDoc(req: {
    syncId: string;
    revisionNo: number;
    workgroupId: string;
  }): Promise<BasicReturnMsg> {
    const resp = await axios.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/contents/checkout/${req.workgroupId}/${req.syncId}/${req.revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
  async undocheckoutManualDoc(req: {
    syncId: string;
    revisionNo: number;
    workgroupId: string;
  }): Promise<BasicReturnMsg> {
    const resp = await axios.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/contents/undocheckout/${req.workgroupId}/${req.syncId}/${req.revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
  async createFolder(folder: FileFolderReq): Promise<FolderInfoDTO> {
    const resp = await axios.post<FolderInfoDTO>(
      `${GATEWAY_URL}/wapi/contents/folder/create`,
      folder
    );
    return Promise.resolve(resp.data);
  }
  async updateFolder(folder: FileFolderReq): Promise<FolderInfoDTO> {
    const resp = await axios.post<FolderInfoDTO>(
      `${GATEWAY_URL}/wapi/contents/folder/update`,
      folder
    );
    return Promise.resolve(resp.data);
  }
  async deleteFolder(folder: FileFolderReq): Promise<FolderInfoDTO> {
    const resp = await axios.post<FolderInfoDTO>(
      `${GATEWAY_URL}/wapi/contents/folder/delete`,
      folder
    );
    return Promise.resolve(resp.data);
  }
  async docUploadFileDelivery(
    req: DeliveryUIDRequestRespondDTO
  ): Promise<DeliveryUIDRequestRespondDTO> {
    const resp = await axios.post<DeliveryUIDRequestRespondDTO>(
      `${GATEWAY_URL}/wapi/contents/upload/${req.uniqueId}/delivery`,
      req.syncIds
    );
    return Promise.resolve(resp.data);
  }
  async docUploadRevisionFile(
    uid: string,
    file: FileWithPath,
    syncId: string,
    setProgressPercent: any
  ): Promise<any> {
    const formData = new FormData();
    formData.append("file", file);
    const resp = await axios.post<AxiosResponse>(
      `${GATEWAY_URL}/wapi/contents/upload/${uid}/revision/${syncId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (data) => {
          //Set the progress value to show the progress bar
          data?.total &&
            setProgressPercent(Math.round((100 * data.loaded) / data?.total));
        },
      }
    );
    return Promise.resolve(resp.data);
  }
  async docUploadFileComplete(
    uid: string,
    req: UploadCompleteRequestDTO,
    isLoading?: boolean
  ): Promise<any> {
    let resp;
    if (req.syncId) {
      try {
        resp = isLoading
          ? await axios.post<{ uniqueId: string }>(
              `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete/${req.syncId}`,
              req
            )
          : await axiosNoLoading.post<{ uniqueId: string }>(
              `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete/${req.syncId}`,
              req
            );
        return Promise.resolve(resp.data);
      } catch (error) {
        return Promise.reject({ error: error });
      }
    } else if (!req.isMultiple) {
      try {
        const resp = isLoading
          ? await axios.post<{ uniqueId: string }>(
              `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete`,
              {
                ...req,
                folderId:
                  req.folderId && req.folderId !== ""
                    ? req.folderId
                    : req.workgroupId,
              }
            )
          : await axiosNoLoading.post<{ uniqueId: string }>(
              `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete`,
              {
                ...req,
                folderId:
                  req.folderId && req.folderId !== ""
                    ? req.folderId
                    : req.workgroupId,
              }
            );
        return Promise.resolve(resp.data);
      } catch (error) {
        return Promise.reject({ error: error });
      }
    } else {
      try {
        const resp = await axios.post<{ uniqueId: string }>(
          `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete`,
          {
            ...req,
            folderId:
              req.workgroupId === "NONEWORKGROUP"
                ? ""
                : req.folderId && req.folderId !== ""
                ? req.folderId
                : req.workgroupId,
          }
        );
        return Promise.resolve(resp.data);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  }
  async docUploadFileCompleteDelivery(
    uid: string,
    req: UploadCompleteRequestDTO
  ): Promise<any> {
    try {
      // 전송파일의 경우에 아직 파일업로드 처럼 UI가 생기지 않아서 progress 처리
      const resp = await axios.post<{ uniqueid: string }>(
        `${GATEWAY_URL}/wapi/contents/upload/${uid}/complete/delivery`,
        req
      );
      return Promise.resolve(resp.data);
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async getDocSyncInfo(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<WrapsodySyncInfoResponse> {
    const resp = await axios.get<WrapsodySyncInfoResponse>(
      `${GATEWAY_URL}/wapi/contents/syncInfo/${req.workgroupId}/${req.syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async webCheckin(
    workgroupId: string,
    syncId: string,
    revisionNo: number
  ): Promise<BasicReturnMsg> {
    const resp = await axios.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/contents/webcheckin/${workgroupId}/${syncId}/${revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
  async forceWebCheckin(syncId: string): Promise<BasicReturnMsg> {
    const resp = await axios.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/contents/forceWebCheckin/${syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async doAIDocChat(chatRequest: DocAIChatRequest): Promise<DocAIChatRespond> {
    const resp = await axiosNoLoading.post<DocAIChatRespond>(
      `${GATEWAY_URL}/wapi/ai/chat`,
      chatRequest
    );
    return Promise.resolve(resp.data);
  }
  async closeAIDocChat(convoId: string): Promise<any> {
    const resp = await axios.post<any>(`${GATEWAY_URL}/wapi/ai/chat/end`, {
      convoId,
    });
    return Promise.resolve(resp.data);
  }
  async cancelAIDocChat(request: DocAIChatRequest): Promise<any> {
    const resp = await axios.post<any>(
      `${GATEWAY_URL}/wapi/ai/chat/cancel`,
      request
    );
    return Promise.resolve(resp.data);
  }
  async checkAIDocPermission(syncIds: string[]): Promise<any> {
    const resp = await axios.post<any>(
      `${GATEWAY_URL}/wapi/ai/check/permission`,
      { syncIds }
    );
    return Promise.resolve(resp.data);
  }
  async checkAnswerDocChat(
    request: DocAIChatRequest
  ): Promise<DocAIChatRespond> {
    const resp = await axiosNoLoading.post<DocAIChatRespond>(
      `${GATEWAY_URL}/wapi/ai/chat/check-answer`,
      request
    );
    return Promise.resolve(resp.data);
  }
  async getFolderInfo(folderId: string): Promise<Folder> {
    const resp = await axios.get<Folder>(
      `${GATEWAY_URL}/wapi/contents/folder/info/${folderId}`
    );
    return Promise.resolve(resp.data);
  }
  async updateFileFolder(
    folder: FileFolderReq
  ): Promise<FolderTagFilesUpdateResponse> {
    const resp = await axios.post<FolderTagFilesUpdateResponse>(
      `${GATEWAY_URL}/wapi/contents/folder/file/update`,
      folder
    );
    return Promise.resolve(resp.data);
  }
  async getUploadDocsProgress(uid: string): Promise<any> {
    const resp = await axios.get<any>(
      `${GATEWAY_URL}/wapi/contents/upload/${uid}`
    );
    return Promise.resolve(resp.data);
  }
  async getDocTimeline(req: {
    workgroupId: string;
    syncId: string;
  }): Promise<DocumentLogResult> {
    const resp = await axiosNoLoading.get<any>(
      `${GATEWAY_URL}/wapi/contents/detail/timeline/${req.workgroupId}/${req.syncId}`
    );
    return Promise.resolve(resp.data);
  }
  async getDocUserViewCount(req: {
    syncId: string;
    workgroupId: string;
  }): Promise<UserViewCountPolicy[]> {
    const resp = await axios.get<UserViewCountPolicy[]>(
      `${GATEWAY_URL}/wapi/contents/viewcount/${req.workgroupId}/${req.syncId}`
    );
    return Promise.resolve(resp.data);
  }
}
const docApi: DocApi = new DocServerApi();
export default docApi;
